import { FormLabel, Grid, Typography } from "@mui/material";
import FileInput from "../../../components/upload/FileInput";
import { AFFECTED_EAR } from "../../../utils/constants";
import CustomInput from "../../../components/inputs/CustomInput";
import SubmitButton from "../../../components/button/SubmitButton";
import CameraCaptureComponent from "../../../components/CameraCaptureComponent";
import { useState } from "react";

const UploadReferences = ({ fields, setFields, loading, handleCaptureMeasurement}) => {
  const [isCameraCapturedFront, setIsCameraCapturedFront] = useState(false);
  
  const handleFileUpload = (key, fileUrl) => {
    setFields((prev) => ({ ...prev, err: "", [key]: fileUrl  }));
  };

// console.log("first ref_image_left_Head", fields?.audiogram_report);
  return (
    <Grid container spacing={4}>
      <Grid item xs={11.5} sx={{ ml: 3 }}>
        <Grid container spacing={3}>

          {/* Audiogram Report Upload */}
          <Grid item xs={12} md={6}>
            <FileInput
              onDelete={() => {
                handleFileUpload("audiogram_report", null);
              }}
              onChange={(fileUrl) =>
                handleFileUpload("audiogram_report", fileUrl)
              }
              defaults={
                fields?.audiogram_report ? [fields.audiogram_report] : []
              }
              accept="image/png, image/jpeg, image/jpg, application/pdf"
              title="Audiogram Report"
              subTitle="Only PNG, JPEG, JPG, PDF files allowed! (Max 10MB)"
            />
          </Grid>

          {/* Front Head Reference Image */}
          <Grid item xs={12} md={6}>
            <FileInput
              disabled={isCameraCapturedFront}
              onDelete={() => {
                handleFileUpload("ref_image_front_Head", null);
                setIsCameraCapturedFront(false);
              }}
              onChange={(fileUrl) => {
                handleFileUpload("ref_image_front_Head", fileUrl);
                setIsCameraCapturedFront(false);
              }}
              defaults={
                fields?.ref_image_front_Head
                  ? [fields?.ref_image_front_Head]
                  : []
              }
              accept="image/*"
              title="Front Head Reference Image*"
              subTitle="Only PNG, JPEG, JPG files allowed! (Max 10MB)"
            />
            <CameraCaptureComponent onChange={(fileUrl) =>{
                handleFileUpload("ref_image_front_Head", fileUrl);
                setIsCameraCapturedFront(true);
              }}
              onDelete={() => {
                handleFileUpload("ref_image_front_Head", null);
                setIsCameraCapturedFront(false);
              }}
              disabled={fields?.ref_image_front_Head}
            />
          </Grid>

          {/* Both Side Head Reference Images */}
          {fields?.affected_ear !== AFFECTED_EAR?.BOTH ? (
            <Grid item xs={12} md={6}>
              <FileInput
                onDelete={() => { 
                  handleFileUpload(
                    fields?.affected_ear === AFFECTED_EAR?.LEFT
                      ? "ref_image_left_Head"
                      : "ref_image_right_Head",
                    null
                  );
                }}
                onChange={(fileUrl) =>
                  handleFileUpload(
                    fields?.affected_ear === AFFECTED_EAR?.LEFT
                      ? "ref_image_left_Head"
                      : "ref_image_right_Head",
                    fileUrl
                  )
                }
                defaults={
                  fields?.affected_ear === AFFECTED_EAR?.LEFT
                    ? fields?.ref_image_left_Head
                      ? [fields.ref_image_left_Head]
                      : []
                    : fields?.ref_image_right_Head
                    ? [fields.ref_image_right_Head]
                    : []
                }
                accept="image/*"
                title={`Reference Image - ${
                  fields?.affected_ear === AFFECTED_EAR?.LEFT ? "Left" : "Right"
                } Side Head*`}
                subTitle="Only PNG, JPEG, JPG files allowed! (Max 10MB)"
              />
              <CameraCaptureComponent onChange={(fileUrl) =>
                handleFileUpload(
                  fields?.affected_ear === AFFECTED_EAR?.LEFT
                    ? "ref_image_left_Head"
                    : "ref_image_right_Head",
                  fileUrl
                )
              } 
              onDelete={() => {
                  handleFileUpload(
                    fields?.affected_ear === AFFECTED_EAR?.LEFT
                      ? "ref_image_left_Head"
                      : "ref_image_right_Head",
                    null
                  );
                }}
              disabled={!!fields?.ref_image_left_Head || !!fields?.ref_image_right_Head}
              />
            </Grid>
          ) : (
            <>
              {/* Left Side Head */}
              <Grid item xs={12} md={6}>
                <FileInput
                  onDelete={() => {
                    handleFileUpload("ref_image_left_Head", null);
                  }}
                  onChange={(fileUrl) =>
                    handleFileUpload("ref_image_left_Head", fileUrl)
                  }
                  defaults={
                    fields?.ref_image_left_Head
                      ? [fields?.ref_image_left_Head]
                      : []
                  }
                  accept="image/*"
                  title="Left Side Head Reference Image*"
                  subTitle="Only PNG, JPEG, JPG files allowed! (Max 10MB)"
                />
                <CameraCaptureComponent onChange={(fileUrl) =>
                handleFileUpload("ref_image_left_Head",fileUrl)
              } 
              onDelete={() => {
                handleFileUpload("ref_image_left_Head", null);
              }}
              disabled={!!fields?.ref_image_left_Head}
              />
              </Grid>

              {/* Right Side Head */}
              <Grid item xs={12} md={6}>
                <FileInput
                  onDelete={() => {
                    handleFileUpload("ref_image_right_Head", null);
                  }}
                  onChange={(fileUrl) =>
                    handleFileUpload("ref_image_right_Head", fileUrl)
                  }
                  defaults={
                    fields?.ref_image_right_Head
                      ? [fields?.ref_image_right_Head]
                      : []
                  }
                  accept="image/*"
                  title="Right Side Head Reference Image*"
                  subTitle="Only PNG, JPEG, JPG files allowed! (Max 10MB)"
                />
                <CameraCaptureComponent onChange={(fileUrl) =>
                handleFileUpload("ref_image_right_Head",fileUrl)
              } 
              onDelete={() => {
                handleFileUpload("ref_image_right_Head", null);
              }}
              disabled={!!fields?.ref_image_right_Head}
              />
              </Grid>
            </>
          )}
        </Grid>
      </Grid>

      {/* Measurement Field */}
      <Grid container sx={{ ml:4, mt: 4}} >

          <Grid item xs={12} md={3.7} sx={{ mb:1}}>
              <FormLabel
                sx={{ fontWeight: "bold", color: "#A91674", fontSize: "18px" }}
              >
                Measurement *
              </FormLabel>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Enter the measurement in centimeter(cm).
              </Typography>

              <SubmitButton 
                sx={{ height: "7vh" }}
                title="Add Measurement" 
                type="button" 
                onClick={handleCaptureMeasurement}
              />
          </Grid>

          <Grid container xs={12} sx={{ display: "flex"}} spacing={3} md={12}>
            <Grid item xs={12} md={4}>
            <CustomInput
              disabled={loading}
              value={fields?.upperHeadCircumference}
              onChange={(e) => {
                const value = e.target.value;
                const validFormat = /^(\d{0,2})(\.\d{0,2})?$/;
                if (value === "" || validFormat.test(value)) {
                setFields({
                  ...fields,
                  err: "",
                  upperHeadCircumference: value
                });
              }
              }}
              label="Temporal Arc (cm)*"
              InputLabelProps={{ shrink: true }}
            />
            </Grid>

            <Grid item xs={12} md={4}>
            <CustomInput
              disabled={loading}
              value={fields?.temporalBoneWidth}
              onChange={(e) => {
                const value = e.target.value;
                const validFormat = /^(\d{0,2})(\.\d{0,2})?$/;
                if (value === "" || validFormat.test(value)) {
                setFields({
                  ...fields,
                  err: "",
                  temporalBoneWidth: value
                });
              }
              }}
              label="Temporal Width (cm)*"
              InputLabelProps={{ shrink: true }}
            />
            </Grid>

            <Grid item xs={12} md={4}>
            <CustomInput
              disabled={loading}
              value={fields?.foreheadToBackheadCircumference}
              onChange={(e) => {
                const value = e.target.value;
                const validFormat = /^(\d{0,2})(\.\d{0,2})?$/;
                if (value === "" || validFormat.test(value)) {
                setFields({
                  ...fields,
                  err: "",
                  foreheadToBackheadCircumference: value
                });
              }
              }}
              label="Head Circumference (cm)*"
              InputLabelProps={{ shrink: true }}
            />
            </Grid>

          </Grid>

      </Grid>
    </Grid>
  );
};

export default UploadReferences;
